import React from 'react'
import PropTypes from 'prop-types'

export default function FilterButton ({
  itemId,
  smallContent,
  largeContent,
  active,
  onClick,
  id,
  children,
  customDisplay,
  buttonClass
}) {
  return (
    <div id={itemId} className={`header-filter-button ${customDisplay ? 'display-range' : ''}`}>
      <button id={id} onClick={onClick} className={`${buttonClass || ''} ${active ? 'active' : ''}`.trim() || null}>
        <span className='only-small-screen'>{smallContent}</span>
        <span className='except-small-screen'>{largeContent}</span>
      </button>
      {children}
    </div>
  )
}
FilterButton.propTypes = {
  active: PropTypes.bool,
  buttonClass: PropTypes.string,
  children: PropTypes.node,
  customDisplay: PropTypes.bool,
  id: PropTypes.string,
  itemId: PropTypes.string,
  largeContent: PropTypes.string,
  onClick: PropTypes.func,
  smallContent: PropTypes.string
}
